import React, { useState } from 'react';
import { Bell, Settings, LogOut, User } from 'lucide-react';
import { useNavigate } from "react-router-dom";


const Navbar = ({ onMenuToggle }) => {
    const navigate = useNavigate();
    const [isLoggingOut, setIsLoggingOut] = useState(false);

    // Fonction de déconnexion
    const handleLogout = async () => {
        setIsLoggingOut(true);

        // Nettoyer les tokens
        localStorage.removeItem('client_token');
        localStorage.removeItem('client_info');
        localStorage.removeItem('expert_token');
        localStorage.removeItem('expert_info');
        localStorage.removeItem('user');
        localStorage.removeItem('role');

        await new Promise(resolve => setTimeout(resolve, 500));

        navigate('/login');
        setIsLoggingOut(false);
    };

    // Fonction pour détecter le type d'utilisateur connecté
    const getUserInfo = () => {
        const expertToken = localStorage.getItem("expert_token");
        const clientToken = localStorage.getItem("client_token");
        
        if (expertToken) {
            const expertInfo = localStorage.getItem("expert_info");
            try {
                return expertInfo ? JSON.parse(expertInfo) : { nom: 'Expert', email: 'expert@cinef.com' };
            } catch {
                return { nom: 'Expert', email: 'expert@cinef.com' };
            }
        }
        
        if (clientToken) {
            const clientInfo = localStorage.getItem("client_info");
            try {
                return clientInfo ? JSON.parse(clientInfo) : { nom: 'Client', email: 'client@cinef.com' };
            } catch {
                return { nom: 'Client', email: 'client@cinef.com' };
            }
        }
        
        return null;
    };

    const userInfo = getUserInfo();

    return (
        <>
            <header className="main-navbar">
                <div className="navbar-container">
                    {/* Left Section - Logo */}
                    <div className="navbar-left">
                        <div className="logo-container">
                            <img src="../assets/images/cinef.png" alt="CINEF Logo" className="logo" />
                        </div>
                    </div>



                    {/* Right Section - Actions */}
                    <div className="navbar-right">
                        {/* Informations utilisateur mobile */}
                        {userInfo && (
                            <div className="mobile-user-info">
                                <div className="user-avatar-mobile">
                                    <User size={18} />
                                </div>
                                <div className="user-details-mobile">
                                    <span className="user-name-mobile">
                                        {userInfo.nom_entreprise || userInfo.nom || userInfo.name || 'Utilisateur'}
                                    </span>
                                </div>
                            </div>
                        )}

                        {/* Bouton de déconnexion mobile */}
                        <button
                            className="mobile-logout-btn"
                            onClick={handleLogout}
                            disabled={isLoggingOut}
                            title="Se déconnecter"
                        >
                            <LogOut size={18} />
                            <span className="logout-text">
                                {isLoggingOut ? 'Déconnexion...' : 'Déconnexion'}
                            </span>
                        </button>

                        {/* Notifications */}
                        {/* <button className="nav-icon-btn"
                            onClick={() => navigate("/notify")}>
                          
                            <Bell size={20} />
                            <span className="notification-dot"></span>
                        </button> */}

                        {/* Settings */}
                        <button
                            className="nav-icon-btn"
                            onClick={() => navigate("/settings")}
                        >
                            <Settings size={20} />
                        </button>


                        {/* User Section */}
                        {/* <div className="user-section">
                            <div className="user-avatar">
                                <div className="avatar-icon">
                                    <User size={18} />
                                </div>
                                <div className="user-info">
                                    <p className="user-name">Entreprise XYZ</p>
                                    <p className="user-role">Client CINEF</p>
                                </div>
                            </div>
                        </div> */}
                    </div>
                </div>
            </header>

            {/* Spacer for fixed navbar */}
            <div className="navbar-spacer"></div>

            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

                .main-navbar {
                    background: linear-gradient(to right, #dc3545, #008A44);
                    box-shadow: 0px 4px 12px rgba(0,0,0,0.15);
                    border-bottom: 3px solid rgba(255, 255, 255, 0.2);
                    position: fixed;
                    top: 0;
                    left: 0;
                    right: 0;
                    z-index: 1050;
                    width: 100%;
                    font-family: 'Inter', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
                }

                .navbar-container {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 0 24px;
                    height: 80px;
                    max-width: 100%;
                }

                .navbar-left {
                    display: flex;
                    align-items: center;
                    flex-shrink: 0;
                }

                // .logo-container {
                //     background: rgba(255, 255, 255, 0.15);
                //     border-radius: 12px;
                //     padding: 8px 12px;
                //     backdrop-filter: blur(10px);
                //     border: 1px solid rgba(255, 255, 255, 0.2);
                //     transition: all 0.3s ease;
                // }

                .logo-container:hover {
                    background: rgba(255, 255, 255, 0.2);
                    transform: translateY(-1px);
                }

                .logo {
                    height: 55px;
                    filter: drop-shadow(0 2px 4px rgba(0,0,0,0.15));
                    transition: transform 0.3s ease;
                }

                .logo:hover {
                    transform: scale(1.05);
                }

                .navbar-center {
                    text-align: center;
                    flex-grow: 1;
                    margin: 0 40px;
                }

                .page-title {
                    font-size: 26px;
                    font-weight: 700;
                    color: #ffffff;
                    margin: 0;
                    line-height: 1.2;
                    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
                    letter-spacing: -0.5px;
                }

                .page-subtitle {
                    font-size: 15px;
                    color: rgba(255, 255, 255, 0.9);
                    margin: 2px 0 0 0;
                    font-weight: 500;
                    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
                }

                .navbar-right {
                    display: flex;
                    align-items: center;
                    gap: 16px;
                    flex-shrink: 0;
                }

                .nav-icon-btn {
                    position: relative;
                    padding: 12px;
                    color: #ffffff;
                    background: rgba(255, 255, 255, 0.15);
                    border: none;
                    border-radius: 10px;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    backdrop-filter: blur(10px);
                    border: 1px solid rgba(255, 255, 255, 0.2);
                }

                .nav-icon-btn:hover {
                    background: rgba(255, 255, 255, 0.25);
                    transform: translateY(-2px);
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
                }

                .notification-dot {
                    position: absolute;
                    top: 8px;
                    right: 8px;
                    width: 10px;
                    height: 10px;
                    border-radius: 50%;
                    background: linear-gradient(45deg, #ff4757, #ff3838);
                    border: 2px solid white;
                    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
                    animation: pulse 2s infinite;
                }

                @keyframes pulse {
                    0% { transform: scale(1); }
                    50% { transform: scale(1.1); }
                    100% { transform: scale(1); }
                }

                .user-section {
                    display: flex;
                    align-items: center;
                    border-left: 2px solid rgba(255, 255, 255, 0.3);
                    padding-left: 20px;
                    margin-left: 12px;
                }

                .user-avatar {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                }

                .avatar-icon {
                    width: 45px;
                    height: 45px;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background: linear-gradient(135deg, #ffffff, #f8f9fa);
                    border: 3px solid rgba(255, 255, 255, 0.8);
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
                    color: #008A44;
                    transition: all 0.3s ease;
                }

                .avatar-icon:hover {
                    transform: scale(1.05);
                    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.25);
                }

                .user-info {
                    display: flex;
                    flex-direction: column;
                }

                .user-name {
                    font-size: 17px;
                    font-weight: 600;
                    color: #ffffff;
                    margin: 0;
                    line-height: 1.2;
                    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
                    letter-spacing: -0.3px;
                }

                .user-role {
                    font-size: 14px;
                    color: rgba(255, 255, 255, 0.85);
                    margin: 0;
                    font-weight: 500;
                    text-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
                }

                /* Mobile User Info Styles */
                .mobile-user-info {
                    display: none;
                    align-items: center;
                    gap: 8px;
                    margin-right: 12px;
                }

                .user-avatar-mobile {
                    width: 32px;
                    height: 32px;
                    background: rgba(255, 255, 255, 0.15);
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: white;
                }

                .user-details-mobile {
                    color: white;
                    font-size: 12px;
                    font-weight: 500;
                }

                .user-name-mobile {
                    max-width: 100px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }

                /* Mobile Logout Button Styles */
                .mobile-logout-btn {
                    display: none;
                    align-items: center;
                    gap: 6px;
                    padding: 8px 12px;
                    background: rgba(255, 255, 255, 0.1);
                    border: 1px solid rgba(255, 255, 255, 0.2);
                    border-radius: 20px;
                    color: white;
                    font-size: 12px;
                    font-weight: 500;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    backdrop-filter: blur(10px);
                }

                .mobile-logout-btn:hover:not(:disabled) {
                    background: rgba(255, 255, 255, 0.2);
                    transform: scale(1.05);
                }

                .mobile-logout-btn:disabled {
                    opacity: 0.6;
                    cursor: not-allowed;
                }

                .logout-text {
                    display: none;
                }

                .navbar-spacer {
                    height: 80px;
                }

                /* Responsive Design */
                @media (max-width: 1200px) {
                    .navbar-container {
                        padding: 0 24px;
                    }
                    
                    .navbar-center {
                        margin: 0 30px;
                    }
                    
                    .page-title {
                        font-size: 24px;
                    }
                }

                @media (max-width: 768px) {
                    .navbar-container {
                        padding: 0 16px;
                        height: 70px;
                    }

                    .navbar-center {
                        margin: 0 20px;
                    }

                    .page-title {
                        font-size: 20px;
                    }

                    .page-subtitle {
                        font-size: 13px;
                    }

                    .user-info {
                        display: none;
                    }

                    .user-section {
                        padding-left: 12px;
                        margin-left: 8px;
                    }

                    .navbar-spacer {
                        height: 70px;
                    }
                }

                @media (max-width: 480px) {                    .mobile-user-info {
                        display: flex;
                    }

                    .mobile-logout-btn {
                        display: flex;
                    }

                    .logout-text {
                        display: inline;
                    }

                    .nav-icon-btn {
                        display: none;
                    }

                    .navbar-container {
                        padding: 0 16px;
                        height: 70px;
                    }

                    .navbar-right {
                        gap: 8px;
                    }
                }

                @media (max-width: 480px) {
                    .mobile-user-info {
                        display: none;
                    }

                    .logout-text {
                        display: none;
                    }

                    .mobile-logout-btn {
                        padding: 10px;
                        border-radius: 50%;
                        min-width: 40px;
                        justify-content: center;
                    }
                    .navbar-container {
                        padding: 0 16px;
                        height: 65px;
                    }

                    .navbar-right {
                        gap: 12px;
                    }

                    .nav-icon-btn {
                        padding: 10px;
                    }

                    .page-title {
                        font-size: 18px;
                    }

                    .page-subtitle {
                        display: none;
                    }

                    .navbar-spacer {
                        height: 65px;
                    }

                    .avatar-icon {
                        width: 40px;
                        height: 40px;
                    }
                }
            `}</style>
        </>
    );
};

export default Navbar;